// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Column_wrapper__tzk8Z","value":"Column_value__Fn2fl"};